import { render } from "./ValoriLimite.vue?vue&type=template&id=52981186"
import script from "./ValoriLimite.vue?vue&type=script&lang=js"
export * from "./ValoriLimite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__